export default __webpack_public_path__ + "static/crankk-c64d1a3affe44b44aadf8daafe95ccfe.png";